'use client';
import { Alert } from '@//components/Alert';
import { OverflowGridItem } from '@//components/OverflowGrid';
import ProductCardContainer from '@//containers/ProductCardContainer';
import ProductCardSkeleton from '@//containers/ProductCardSkeleton';
import useVehicles from '@//data/search/vehicles/useVehicles';
import { useMarketMetadata } from '@//providers/MarketSettingsProvider';

const params = new URLSearchParams('hits=6&hasMedia=true');
const skeletonArray = new Array(3).fill(null);

const StartpageFeaturedVehiclesResult = () => {
  const vehiclesQuery = useVehicles(params);
  const marketMetadata = useMarketMetadata();

  const response = vehiclesQuery.data;
  const latestVehicles = response?.documentList?.documents || [];

  if (vehiclesQuery.isLoading)
    return (
      <>
        {skeletonArray.map((_, index) => (
          <OverflowGridItem key={index}>
            <div role="status" aria-live="polite" className="sr-only">
              Loading search results...
            </div>
            <ProductCardSkeleton key={index} />
          </OverflowGridItem>
        ))}
      </>
    );

  if (vehiclesQuery.isError)
    return <Alert id="alert-error">Det gick inte att hämta annonserna...</Alert>;

  if (!latestVehicles.length)
    return <Alert id="alert-no-vehicles">Det finns inga annonser att visa just nu</Alert>;

  return (
    <>
      {latestVehicles.map((vehicle, index: number) => (
        <OverflowGridItem key={vehicle._id}>
          <ProductCardContainer
            item={vehicle}
            index={index}
            itemPage={marketMetadata.pageLinks.itemPage}
            currency={marketMetadata.currency}
            testId={`featured-vehicle-${index}`}
            loading={index < 3 ? 'eager' : 'lazy'}
            imagePreset="overflowGrid"
            headingLevel={3}
          />
        </OverflowGridItem>
      ))}
    </>
  );
};

export default StartpageFeaturedVehiclesResult;
